import * as React from 'react';
import { SVGProps } from 'react';

const SvgWater = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M3 23c.74-.025 1.44-.244 1.964-.614s.834-.864.87-1.386h2.833c.035.522.345 1.017.87 1.386.523.37 1.223.589 1.963.614.751 0 1.472-.21 2.004-.586.53-.375.83-.884.83-1.414h2.833c0 .53.298 1.04.83 1.414.53.375 1.252.586 2.003.586.751 0 1.472-.21 2.003-.586.532-.375.83-.884.83-1.414h2.834c0 .53.298 1.04.83 1.414.53.375 1.252.586 2.003.586.74-.025 1.44-.244 1.964-.614s.834-.864.87-1.386h2.833c.035.522.345 1.017.87 1.386.523.37 1.223.589 1.963.614"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M3 18.4v17.188h28.237a6.148 6.148 0 0 0 6.138-6.139V18.4"
    />
    <path fill={props.fill} d="M30.237 36.91H2V32h23.306l4.93 4.91Z" />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M19.684 17.65h-.001a4.161 4.161 0 0 1-4.161-4.16c0-1.86.878-3.732 1.84-5.21a17.746 17.746 0 0 1 1.784-2.294 9.495 9.495 0 0 1 .178-.187l.012-.012.005-.005.008-.007.339-.34.338.34.53-.53-.53.53a16.915 16.915 0 0 1 1.986 2.506c.963 1.477 1.841 3.35 1.841 5.208a4.16 4.16 0 0 1-4.169 4.161Z"
    />
  </svg>
);

export default SvgWater;
